module.exports = __webpack_public_path__ + "img/NUTSHELL_GUEST.7af649db.png";